import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2971142431 from "../../../../../packages/component/src/components/tree-select/demo/demo1.js?loadDemo";
import legacyImportDemo_515049884 from "../../../../../packages/component/src/components/tree-select/demo/demo2.js?loadDemo";
import legacyImportDemo_810730397 from "../../../../../packages/component/src/components/tree-select/demo/demo3.js?loadDemo";
import legacyImportDemo_2879484954 from "../../../../../packages/component/src/components/tree-select/demo/demo4.js?loadDemo";
import legacyImportDemo_1976150043 from "../../../../../packages/component/src/components/tree-select/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2971142431,
  legacyImportDemo_515049884,
  legacyImportDemo_810730397,
  legacyImportDemo_2879484954,
  legacyImportDemo_1976150043,
  React
};